export default resResource => {
  if (!resResource) { return null; }
  return JSON.parse(JSON.stringify(resResource));
};